import "./privacy.css";

function BannedProducts() {
  return (
    <>
      <div className="privacy-wrapper">
        <div className="privacy-container">

          <h1 className="main-title">Banned Products</h1>

          <p>
            The following products, materials, and services are strictly prohibited on BusinessBay.io. Users are urged to comply with applicable laws and site policies.
          </p>

          <ul className="banned-list">
            <li>Adult Products and Pornographic/Obscene Materials (including child pornography)</li>
            <li>Alcohol</li>
            <li>Animals, whether live or dead, including their parts and products</li>
            <li>Any article/material/service prohibited by law or site regulations</li>
            <li>Counterfeit Goods and goods/materials infringing intellectual property rights</li>
            <li>Currency, Negotiable Instruments, etc.</li>
            <li>Endangered species of animals and plants</li>
            <li>Firearms, ammunition, weapons, knives, and parts thereof</li>
            <li>Financial Services</li>
            <li>Grey market products</li>
            <li>Hazardous materials (explosives, chemicals, flammable liquids, pesticides, etc.)</li>
            <li>Human remains or skeletons</li>
            <li>Invoices (including blank, pre-filled, or value-added invoices)</li>
            <li>Liquefied Petroleum Gas (LPG) cylinders</li>
            <li>Incorrect maps and literature showing Indian boundaries</li>
            <li>Narcotic Drugs and Psychotropic Substances</li>
            <li>Government-related items/equipment (wireless, uniforms, etc.)</li>
            <li>Prescription Medicines and Drugs</li>
            <li>Racially/ethnically/religiously offensive materials</li>
            <li>Radioactive Materials</li>
            <li>Reptile skins</li>
            <li>Sex Determination Kits</li>
            <li>Stocks and Securities</li>
            <li>Stolen Properties</li>
            <li>Unauthorized Copies of Intellectual Property</li>
            <li>Veterinary Drugs for animals</li>
            <li>Wildlife and Animal Products</li>
            <li>Passports and other government-issued personal documents</li>
            <li>Any other sanctioned or prohibited items as per law</li>
          </ul>

          <p>
            For any queries regarding banned products or listing compliance, please contact <a href="mailto:info@businessbay.io" className="email">info@businessbay.io</a>.
          </p>

        </div>
      </div>
    </>
  );
}

export default BannedProducts;